import React from 'react';
import Icon from './Icon';
import { useI18n } from '../i18n';

// A polished, clearly-fictional sample of what Decode My Student returns. This is
// static marketing copy — NOT a live AI result and NOT a real student record.
// The "Example" labelling is deliberate and must stay visible.

export default function DemoPreview() {
  const { t, tm } = useI18n();
  const tryToday = tm<string[]>('demoPreview.tryToday');
  return (
    <div style={{ padding: '48px 0' }}>
      <div className="mkt-inner mkt-faq">
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <h2 style={{ fontSize: 26, marginBottom: 8 }}>{t('demoPreview.title')}</h2>
          <p style={{ color: 'var(--text-secondary)', fontSize: 15, lineHeight: 1.6 }}>
            {t('demoPreview.subtitle')}
          </p>
        </div>

        <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
          {/* Example banner */}
          <div style={{ background: 'var(--amber-light)', color: '#b87800', padding: '8px 16px', fontSize: 12, fontWeight: 700, letterSpacing: 0.4, display: 'flex', alignItems: 'center', gap: 8 }}>
            <Icon name="sparkle" size={15} /> {t('demoPreview.exampleBanner')}
          </div>

          <div style={{ padding: '20px' }}>
            {/* The situation */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
              <span className="mono" style={{ fontSize: 18, fontWeight: 500, color: 'var(--teal)' }}>J.S.</span>
              <span style={{ fontSize: 13, color: 'var(--text-secondary)' }}>{t('demoPreview.grade')}</span>
            </div>
            <p style={{ fontSize: 15, color: 'var(--charcoal)', fontStyle: 'italic', marginBottom: 20 }}>
              {t('demoPreview.quote')}
            </p>

            {/* What may be driving it */}
            <p style={{ fontSize: 13, fontWeight: 700, letterSpacing: 0.6, color: 'var(--teal)', marginBottom: 6 }}>{t('demoPreview.drivingLabel')}</p>
            <p style={{ fontSize: 15, color: 'var(--charcoal)', lineHeight: 1.6, marginBottom: 20 }}>
              {t('demoPreview.driving')}
            </p>

            {/* Three things to try */}
            <p style={{ fontSize: 13, fontWeight: 700, letterSpacing: 0.6, color: 'var(--teal)', marginBottom: 8 }}>{t('demoPreview.tryLabel')}</p>
            <div style={{ marginBottom: 20 }}>
              {tryToday.map((line, i) => (
                <div key={i} style={{ display: 'flex', gap: 12, alignItems: 'flex-start', marginBottom: 10 }}>
                  <span style={{ width: 24, height: 24, borderRadius: '50%', background: 'var(--amber)', color: '#fff', fontSize: 13, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>{i + 1}</span>
                  <p style={{ fontSize: 15, color: 'var(--charcoal)', lineHeight: 1.5 }}>{line}</p>
                </div>
              ))}
            </div>

            {/* Words to use */}
            <p style={{ fontSize: 13, fontWeight: 700, letterSpacing: 0.6, color: 'var(--teal)', marginBottom: 6 }}>{t('demoPreview.wordsLabel')}</p>
            <div style={{ background: 'var(--teal-light)', borderRadius: 10, padding: '14px 16px', marginBottom: 20 }}>
              <p style={{ fontSize: 15, color: 'var(--charcoal)', lineHeight: 1.6, fontStyle: 'italic' }}>
                {t('demoPreview.words')}
              </p>
            </div>

            {/* When to escalate */}
            <p style={{ fontSize: 13, fontWeight: 700, letterSpacing: 0.6, color: 'var(--coral)', marginBottom: 6 }}>{t('demoPreview.escalateLabel')}</p>
            <p style={{ fontSize: 15, color: 'var(--charcoal)', lineHeight: 1.6 }}>
              {t('demoPreview.escalate')}
            </p>
          </div>
        </div>

        <p style={{ textAlign: 'center', fontSize: 13, color: 'var(--text-secondary)', marginTop: 14 }}>
          {t('demoPreview.footnote')}
        </p>
      </div>
    </div>
  );
}
